module.exports = __webpack_public_path__ + "static/QUUBRegular-7170efa1ea0bc3d4a863e876eedfb0e4.ttf";